import * as React from 'react';

import Icon from '../icon';
import Box from '../box';
import Spinner from '../spinner';
import Button from '../button';
import {
	Root,
	WrapLayout,
	IconLayout,
	TitleLayout,
	Title,
	Detail,
	ControlsLayout,
	ButtonLayout,
} from './styled';


export type ConfirmDialogProps = {
	title?: React.ReactNode;
	description?: React.ReactNode;
	actionLabel?: string;
	isFetching?: boolean;
	disabled?: boolean;
	onAction?: (e: React.SyntheticEvent) => void;
	onClose?: (e: React.SyntheticEvent) => void;
}

const ConfirmDialog: React.SFC<ConfirmDialogProps> = props => {
	const {
		title,
		description,
		actionLabel,
		isFetching,
		disabled,
		onAction,
		onClose
	} = props;

	if (isFetching) {
		return (
			<Root>
				<Box height={200} display='flex' justifyContent='center' alignItems='center'>
					<Spinner />
				</Box>
			</Root>
		);
	}

	return (
		<Root>
			<WrapLayout>
				<IconLayout>
					<Icon
						type='result-success'
						color='danger'
						width={100}
						height={100} />
				</IconLayout>
				<TitleLayout>
					<Title>{title}</Title>
					<Detail>{description}</Detail>
				</TitleLayout>
				<ControlsLayout centered={!actionLabel}>
					{
						actionLabel &&
						<ButtonLayout>
							<Button
								disabled={disabled}
								onClick={onAction}>
								{actionLabel}
							</Button>
						</ButtonLayout>
					}
					<ButtonLayout>
						<Button
							color='default'
							disabled={disabled}
							onClick={onClose}>
							Отмена
						</Button>
					</ButtonLayout>
				</ControlsLayout>
			</WrapLayout>
		</Root>
	);
};

export default ConfirmDialog;
